import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Burger = ({
  size,
  type,
  theme,
  className,
  dataTestId = "burger-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path d="M1.99998 2.33337C1.63179 2.33337 1.33331 2.63185 1.33331 3.00004C1.33331 3.36823 1.63179 3.66671 1.99998 3.66671H14C14.3682 3.66671 14.6666 3.36823 14.6666 3.00004C14.6666 2.63185 14.3682 2.33337 14 2.33337H1.99998Z" />
    <path d="M1.99998 7.33337C1.63179 7.33337 1.33331 7.63185 1.33331 8.00004C1.33331 8.36823 1.63179 8.66671 1.99998 8.66671H14C14.3682 8.66671 14.6666 8.36823 14.6666 8.00004C14.6666 7.63185 14.3682 7.33337 14 7.33337H1.99998Z" />
    <path d="M1.33331 13C1.33331 12.6319 1.63179 12.3334 1.99998 12.3334H14C14.3682 12.3334 14.6666 12.6319 14.6666 13C14.6666 13.3682 14.3682 13.6667 14 13.6667H1.99998C1.63179 13.6667 1.33331 13.3682 1.33331 13Z" />
  </SVGIcon>
);
